export default __webpack_public_path__ + "static/media/logo-white.349416eb.png";